/**
 * 티켓 주소를 만드는 자리 — **모양의 주인은 여기 하나다.**
 *
 * `/tickets/:id` 페이지는 없다(2026-08-29 지시: 상세는 무조건 모달).
 * 이 주소는 **보드를 그리면서 그 티켓의 모달을 연다** — 라우트는 `App.tsx`,
 * 여는 쪽은 `BoardPage` 다.
 * 셋(여기·라우트·보드)이 같은 모양을 봐야 하므로, 라우트 모양을 바꾸면
 * 여기도 같이 바꿔라.
 *
 * key(`PLUS-118`)가 아니라 **id 로 만든다.** 번호는 전역 통번호라 id 와
 * 같은 수이고, 서버 API(`GET /tickets/{id}`)가 받는 것도 id 다 — key 로
 * 만들면 여는 쪽이 프로젝트 키를 떼는 일을 하나 더 진다.
 */

export function ticketPath(id: number): string {
  return `/tickets/${id}`;
}

/** 남에게 건네는 절대 주소. */
export function ticketUrl(id: number): string {
  return `${window.location.origin}${ticketPath(id)}`;
}

/**
 * 글자를 클립보드에 넣는다. **성공 여부를 돌려준다** — 부르는 쪽이
 * 「복사했다」를 말하려면 정말 됐는지 알아야 한다. 조용한 실패는
 * 「복사한 줄 알고 빈 것을 붙여 넣는」 사고가 된다.
 *
 * `navigator.clipboard` 는 안전한 문맥(https·localhost)에만 있다.
 * 없거나 거부되면 보이지 않는 textarea + `execCommand('copy')` 로
 * 우회한다 — 낡은 길이지만 그 자리에서는 그것뿐이다.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // clipboard API 가 없거나 거부됐다 — 아래 우회로 내려간다.
  }
  try {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    // 화면 밖으로 밀지 않고 **투명**으로 둔다 — 밖으로 밀면 브라우저가
    // 포커스를 따라가며 스크롤이 튄다.
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const done = document.execCommand('copy');
    area.remove();
    return done;
  } catch {
    return false;
  }
}
